import { defineStore } from "pinia";
import type { WebModelGetHub } from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import { getAllHubs } from "~/model/api/pLCnextStoreFrontendAPI";
import { withErrorHandling } from "~/helpers/withErrorHandling";
import { withErrorMessage } from "~/helpers/withErrorMessage";
import { withLoading } from "~/helpers/withLoading";

interface State {
  hubs: WebModelGetHub[];
}

export const useHubsStore = defineStore("hubs", {
  // convert to a function
  state: (): State => ({
    hubs: [], // initial state
  }),
  getters: {
    getHubPriceWithCurrency:
      (state) => (hubName: string, price: string | number) => {
        if (!price) {
          return "N/A";
        }
        if (!state.hubs || state.hubs.length === 0) {
          return "";
        }
        for (let i = state.hubs.length - 1; i >= 0; i--) {
          if (state.hubs[i]?.name === hubName) {
            const before = state.hubs[i]?.currencyShortBefore
              ? state.hubs[i]?.currencyShortBefore
              : "";
            return `${before} ${price} ${state.hubs[i]?.currencyShortAfter}`;
          }
        }
        return "";
      },
    getHubCurrencyShort: (state) => (hubName: string) => {
      if (!state.hubs || state.hubs.length === 0) {
        return "";
      }
      for (let i = state.hubs.length - 1; i >= 0; i--) {
        if (state.hubs[i]?.name === hubName) {
          const before = state.hubs[i]?.currencyShortBefore
            ? state.hubs[i]?.currencyShortBefore
            : "";
          return `${before} ${state.hubs[i]?.currencyShortAfter ?? ""}`.trim();
        }
      }
      return "";
    },
  },
  actions: {
    async loadHubs() {
      const { data, error } = await withErrorHandling(
        withErrorMessage(withLoading(getAllHubs())),
      );
      console.debug("loadHubs: ", data, error);
      if (data) {
        this.hubs = data;
      }
    },

    // easily reset state using `$reset`
    clear() {
      this.$reset();
    },
  },
});
